import React, { useState } from "react";
import db from "../../../../db/index.json";
import Breadcrumbs from '../../../reusebale/breadcrumbs'
import StaffInfo from './staffInfo'
import PreviousShift from "./previousShift"

const DetailStaffMain = ({ onBack, selectedStaff }) => {
  const { support } = db;


  return (
    <div className="mt-4 h-full">
      <Breadcrumbs
        classes={`text-darkColor font-popinsSemiBold text-xl`}
        subheading="Staff Info"
        content={`${selectedStaff?.firstName} ${selectedStaff?.lastName} `}
        onBack={onBack}
      />

      <StaffInfo selectedStaff={selectedStaff} />
      <PreviousShift selectedStaff={selectedStaff} />
    </div>
  );
};

export default DetailStaffMain;
